import React, { forwardRef } from 'react';
import { Box } from '@mui/material';
import {
  useDataProvider,
  CRUD_COMPONENT_TYPE,
  CRUDComponent,
} from '@ui-framework/index';
import { observer } from 'mobx-react';

import {
  claimNumber,
  claimStatus,
  totalAmountApproved,
  createdDateTime,
  lastModifiedDateTime,
} from './accessorFunctions';
import listSchema from './list.json';

const JobClaimHistory = forwardRef((props, ref) => {
  const { setCurrentClaimId, setOpen, setShowAddClaim, hideAddClaimStatuses } =
    props;
  const provider =
    process.env.NODE_ENV === 'development' ? 'sxclServices' : 'default';
  const dataProvider = useDataProvider(provider);

  const listApiUrl = `${dataProvider.getApiUrl()}/sxcl/v1/service-jobs/${
    props.jobId
  }/claims`;

  const listProps = {
    columnPrimaryId: 'id',
    dataProvider,
    schema: listSchema,
    initialState: {
      showColumnFilters: false,
    },
    downloadApiUrl: null,
    listApiUrl,
    accessorFunctions: {
      claimNumber,
      claimStatus,
      totalAmountApproved,
      createdDateTime,
      lastModifiedDateTime,
    },
    sortBy: 'createdDateTime',
    sortOrder: 'DESC',
    storeName: 'JobClaimHistory',
    accessorFunctionsAdditional: {
      setCurrentClaimId,
      setOpen,
    },
    onApiResponse: response => {
      if (response?.ok) {
        const claims = response?.data?.data;
        const hideClaim = claims?.some(c => {
          return hideAddClaimStatuses.includes(c.claimStatus.toUpperCase());
        });
        setShowAddClaim(!hideClaim);
      }
    },
  };

  return (
    <Box ref={ref}>
      <CRUDComponent type={CRUD_COMPONENT_TYPE.LIST2} listProps={listProps} />
    </Box>
  );
});

export default observer(JobClaimHistory);
